import * as React from "react";

import './ReviewBreakdown.scss';

const ReviewBreakdown = ({ reviewCounts, totalReviews }) => {
    const calculateWidth = (count) => {
        return (count / totalReviews) * 100 + '%';
    };

    return (
        <div className="reviews__breakdown">
            {Object.keys(reviewCounts).map((rating) => (
                <div key={rating} className="review__bar-container">
                    <div className="review__bar-title">{rating}</div>
                    <div className="review__bar">
                        <div
                            className="review__bar-display"
                            style={{width: calculateWidth(reviewCounts[rating])}}
                        ></div>
                    </div>
                    <div className="review__bar-summary">{reviewCounts[rating]}</div>
                </div>
            ))}
        </div>
    );
};

export default ReviewBreakdown;
